import type { ScoreBreakdown } from "../types";

export function streakMultiplier(streak: number): number {
  if (streak >= 9) return 2.0;
  if (streak >= 6) return 1.5;
  if (streak >= 3) return 1.2;
  return 1.0;
}

export function pointsForCorrect(tryIndex: number, streakAfter: number): number {
  const base = tryIndex <= 1 ? 100 : tryIndex === 2 ? 60 : 30;
  return Math.round(base * streakMultiplier(streakAfter));
}

export function timeBonus(secondsLeft: number): number {
  return Math.ceil(Math.max(0, secondsLeft) * 8);
}

export function starsFor(
  finished: boolean,
  firstTry: number,
  steps: number,
  secondsLeft: number
): 0 | 1 | 2 | 3 {
  if (!finished || steps <= 0) return 0;
  const acc = firstTry / steps;
  if (acc >= 0.9 && secondsLeft >= 20) return 3;
  if (acc >= 0.7) return 2;
  return 1;
}

export function finalizeScore(args: {
  stepPoints: number;
  finished: boolean;
  misses: number;
  firstTry: number;
  stepsDone: number;
  pathLength: number;
  secondsLeft: number;
  timeMs: number;
  streakBest: number;
}): ScoreBreakdown {
  const tb = args.finished ? timeBonus(args.secondsLeft) : 0;
  const pb = args.finished && args.misses === 0 ? 250 : 0;
  const total = args.stepPoints + tb + pb;
  return {
    stepPoints: args.stepPoints,
    timeBonus: tb,
    perfectBonus: pb,
    total,
    misses: args.misses,
    firstTry: args.firstTry,
    stepsDone: args.stepsDone,
    pathLength: args.pathLength,
    finished: args.finished,
    stars: starsFor(args.finished, args.firstTry, args.pathLength, args.secondsLeft),
    streakBest: args.streakBest,
    secondsLeft: Math.max(0, args.secondsLeft),
    timeMs: args.timeMs,
  };
}

export function scoreFromEvents(
  events: Array<{ ok: boolean; tryIndex: number }>,
  opts: { finished: boolean; pathLength: number; secondsLeft: number; timeMs: number }
): ScoreBreakdown {
  let stepPoints = 0;
  let streak = 0;
  let streakBest = 0;
  let misses = 0;
  let firstTry = 0;
  let stepsDone = 0;
  for (const e of events) {
    if (e.ok) {
      streak += 1;
      if (streak > streakBest) streakBest = streak;
      stepPoints += pointsForCorrect(e.tryIndex, streak);
      stepsDone += 1;
      if (e.tryIndex === 1) firstTry += 1;
    } else {
      streak = 0;
      misses += 1;
    }
  }
  return finalizeScore({
    stepPoints,
    finished: opts.finished,
    misses,
    firstTry,
    stepsDone,
    pathLength: opts.pathLength,
    secondsLeft: opts.secondsLeft,
    timeMs: opts.timeMs,
    streakBest,
  });
}
